import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundOff = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.8407 45.288C23.6712 45.7032 24.5018 45.9109 25.4361 45.9109C26.3705 45.9109 27.3049 45.7032 28.2392 45.288C29.9003 44.2498 30.8347 42.5887 30.8347 40.8238V9.88572C30.8347 8.01698 29.9003 6.35587 28.2392 5.4215C26.5781 4.48713 24.5018 4.38331 22.8407 5.31768L9.75947 14.4537H5.19143C2.2845 14.4537 0.000488281 16.7378 0.000488281 19.6447V31.0648C0.000488281 33.9717 2.2845 36.2557 5.19143 36.2557H9.75947L22.633 45.1842L22.8407 45.288ZM25.6438 40.7199C25.6438 40.8238 25.5399 40.8238 25.4361 40.8238L11.4206 31.0648H5.19143V19.6447H11.4206L25.4361 9.7819C25.4361 9.7819 25.5399 9.88572 25.6438 9.88572V40.7199Z",
		fill: "#002938"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M37.1847 18.5621C37.9163 17.764 39.1564 17.7101 39.9545 18.4417L43.4805 21.6738L46.6537 18.5006C47.4193 17.735 48.6605 17.735 49.4261 18.5006C50.1917 19.2662 50.1917 20.5075 49.4261 21.2731L46.3735 24.3257L49.3645 27.0675C50.1626 27.7991 50.2165 29.0392 49.4849 29.8373C48.7533 30.6354 47.5132 30.6894 46.7151 29.9577L43.5984 27.1008L40.8003 29.8988C40.0347 30.6644 38.7935 30.6644 38.0279 29.8988C37.2623 29.1333 37.2623 27.892 38.0279 27.1264L40.7054 24.4489L37.3052 21.332C36.507 20.6004 36.4531 19.3603 37.1847 18.5621Z",
		fill: "#002938"
	})]
});
const ForwardRef = forwardRef(SvgSoundOff);
export default ForwardRef;
